import { c as _c } from "react/compiler-runtime";
import { COURSE_BUNDLES_API } from 'modules/courses/bundles/api/course-bundles-api';
import { CourseBundleApiInterface } from 'modules/courses/bundles/types/course-bundle-interface';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { SwrPaginationInterface } from 'shared/types/pagination-interface';
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string';
import { baseFetcher } from 'shared/utils/http-client';
export function useCourseBundles(t0) {
  const $ = _c(10);
  const {
    limit,
    pagination
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== limit || $[2] !== pagination) {
    t2 = () => [`${COURSE_BUNDLES_API}/list?${getPaginationQueryString({
      limit,
      pagination
    })}`, RequestModuleEnum.CourseBundle];
    $[1] = limit;
    $[2] = pagination;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data: courseBundles,
    mutate
  } = useControlledSwr(t2, fetcher, undefined, !!user);
  let t3;
  if ($[4] !== user) {
    t3 = () => {
      if (user) {
        return [`${COURSE_BUNDLES_API}/count?pagination[limit]`, RequestModuleEnum.CourseBundle];
      }
      return null;
    };
    $[4] = user;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data: counter
  } = useControlledSwr(t3, baseFetcher);
  let t4;
  if ($[6] !== counter || $[7] !== courseBundles || $[8] !== mutate) {
    t4 = {
      courseBundles,
      mutate,
      counter
    };
    $[6] = counter;
    $[7] = courseBundles;
    $[8] = mutate;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}